<template>
  <section class="ui-intro" :class="{ 'ui-intro--app' : $inApp }">
    <div class="ui-intro__content">
      <transition @enter="enter" @leave="leave" mode="out-in">
        <div
          class="content__body content__body--intro"
          v-if="!$store.state.characterSelection"
          :key="!$store.state.characterSelection"
        >
          <p class="content__text" v-html="message"/>

          <ShareButton
            class="content__share"
            v-if="$inApp && $isLogged && $store.state.userData.scoreRange.length > 0"
          />

          <ScoreTable
            class="content__table"
            v-if="$inApp && $isLogged && $store.state.userData.scoreRange.length > 0"
          />

          <RoundedButton
            class="content__button"
            :content="$translate('start')"
            action="selectCharacter"
          />
        </div>

        <div
          class="content__body content__body--selection"
          v-else
        >
          <CharacterSelection data-animation="slider"/>

          <p class="selection__button" data-animation="fade">
            {{ $translate('characterSelection') }}
          </p>

          <RoundedButton
            class="content__button"
            :content="$translate('play')"
            action="startPlaying"
            data-animation="roundedButton"
          />
        </div>
      </transition>

      <Cookie class="content__cookie" v-if="!$inApp && !$store.state.characterSelection"/>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { initials, enter, leave } from '@/scripts/animations';
import ShareButton from '@/components/ShareButton.vue';
import ScoreTable from '@/components/ScoreTable.vue';
import RoundedButton from '@/components/RoundedButton.vue';
import Cookie from '@/components/Cookie.vue';
import CharacterSelection from '@/components/CharacterSelection.vue';

export default {
  name: 'UIintro',

  components: {
    ShareButton,
    RoundedButton,
    ScoreTable,
    CharacterSelection,
    Cookie,
  },

  computed: {
    message() {
      let message;

      switch (true) {
        case this.$inApp && this.$isLogged:
          message = `
            ${this.$translate('welcome').firstVisit.firstText} ${this.$store.state.userData.userName} ${this.$translate('welcome').firstVisit.secondText}
          `;
          break;

        default:
          message = this.$translate('welcome').noApp;
          break;
      }

      return message;
    },
  },

  methods: {
    enter(el, done) {
      const fade = el.querySelector('[data-animation="fade"]');
      const slider = el.querySelector('[data-animation="slider"]');
      const roundedButton = el.querySelector('[data-animation="roundedButton"]');

      initials.get('fade')(fade);
      initials.get('slider')(slider);
      initials.get('roundedButton')(roundedButton);

      const tl = gsap.timeline({ onComplete: done });

      tl.addLabel('start')
        .add(enter.get('slider')(slider), 'start')
        .add(enter.get('fade')(fade), 'start+=0.5')
        .add(enter.get('roundedButton')(roundedButton), 'start+=1');
    },
    leave(el, done) {
      const tl = gsap.timeline({ onComplete: done });

      tl.addLabel('start')
        .add(leave.get('fade')(el, -20), 'start');
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-intro {
  color: $red;

  &.ui-intro--app {
    .ui-intro__content {
      bottom: 10vh;
    }

    .ui-intro__logo {
      margin-top: 8vh;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  &__content {
    position: absolute;
    width: 100%;
    bottom: 20px;

    .content__body {
      height: 60vh;

      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-flow: column nowrap;
      text-align: center;

      &.content__body--selection {
        height: 62vh;

        @include mq(ipadP) {
          height: 70vh;
        }
      }
    }
  }

  .selection__button {
    text-align: center;
    @extend %font-small-but;
  }

  .content__cookie {
    color: $red;
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    &__content {
      .content__body {
        height: 70vh;
      }
    }
  }

  @include mq(ipadP) {
    .ui-intro__logo {
      margin-top: 8vh;
    }
  }

  @include mq(ipadP, $and: $is-portrait) {
    .ui-intro__logo {
      margin-top: 9vh;
    }
  }
}
</style>
